module.exports = __webpack_public_path__ + "static/rewards-card-xbox-live-gold-a21514cb6514fe262615748480be8642.png";